import React, { useState } from "react";

import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { Table } from "antd";
import { Key, SorterResult, TableCurrentDataSource, TablePaginationConfig } from "antd/lib/table/interface";

import { DeeplinkModal } from "../../../../components/modals";
import { ClickModal } from "../../../../components/modals/click_modal";
import { ColumnTitle } from "../../../../components/table";
import { Deeplink } from "../../../../store/common_types";
import { FeedbackItem } from "../../../../store/feedbacks/types";

import styles from "./styles.module.scss";

const columns = (t: TFunction, onMarkerClick: (marker: string) => void) => [
  {
    key: "createdAt",
    title: <ColumnTitle title={t("table.columns.createdAt.title")} helpText={t("table.columns.createdAt.helpText")} />,
    dataIndex: "createdAt",
  },
  {
    key: "marker",
    title: <ColumnTitle title={t("table.columns.marker.title")} />,
    dataIndex: "marker",
    render: (value?: string) => value && <a onClick={() => onMarkerClick(value)}>{value}</a>,
  },
  {
    key: "text",
    title: <ColumnTitle title={t("table.columns.text.title")} helpText={t("table.columns.text.helpText")} />,
    dataIndex: "text",
    className: styles.feedback,
  },
];

export interface DataTableProps {
  loading?: boolean;
  totalFeedbacks: number;
  dataSource: FeedbackItem[];
  currentPage: number;
  pageSize?: number;
  onChange?: (
    pagination: TablePaginationConfig,
    filters: Record<string, (Key | boolean)[] | null>,
    sorter: SorterResult<FeedbackItem> | SorterResult<FeedbackItem>[],
    extra: TableCurrentDataSource<FeedbackItem>
  ) => void;
}

export const DataTable: React.FC<DataTableProps> = (props) => {
  const { t, i18n } = useTranslation("feedbacks_page");
  const [deeplinkModal, setDeeplinkModal] = useState<{ visible: boolean; deeplink: Deeplink | undefined }>({
    visible: false,
    deeplink: undefined,
  });
  const [clickDrawer, setClickDrawer] = useState<{ visible: boolean; marker: string | undefined }>({
    visible: false,
    marker: undefined,
  });

  const handleDeeplinkClick = (deeplink: Deeplink) => {
    setDeeplinkModal({ visible: true, deeplink });
  };
  const handleDeeplinkModalClose = () => {
    setDeeplinkModal((state) => ({ ...state, visible: false }));
  };

  const handleMarkerClick = (marker: string) => {
    setClickDrawer({ visible: true, marker });
  };
  const handleClickDrawerClose = () => {
    setClickDrawer((state) => ({ ...state, visible: false }));
  };

  return (
    <>
      <DeeplinkModal onClose={handleDeeplinkModalClose} {...deeplinkModal} />
      <ClickModal onClose={handleClickDrawerClose} onDeeplinkClick={handleDeeplinkClick} {...clickDrawer} />
      <Table
        bordered
        loading={props.loading}
        columns={columns(t, handleMarkerClick)}
        dataSource={props.dataSource}
        onChange={props.onChange}
        rowKey={(record: FeedbackItem) => `bookings-row-${record.id}`}
        footer={() => `${i18n.t("common:table.total")}: ${props.totalFeedbacks}`}
        pagination={{
          total: props.totalFeedbacks,
          current: props.currentPage,
          pageSize: props.pageSize,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
        size="small"
      />
    </>
  );
};
